import Link from "next/link";

import { useStoreContext } from "@components/store/provider";
import { useWithAnalytics } from "@stadium/services/analytics/hooks/use-with-analytics";

import { getBrandRoute } from "@constants/routes";

import { HEADER_ANALYTICS_TARGET } from "@stadium/shared/src/constants/analytics/header";
import {
  ANALYTICS_TARGET_BRAND,
  ANALYTICS_EVENT_ACTION_PERFORMED,
} from "@stadium/services/analytics/constants/default";

import defaultStyles from "./main.module.scss";

const SearchedBrand = ({ data, styles = defaultStyles, handleClick }) => {
  const { id, name, key } = data;
  const { storeBasePath } = useStoreContext();
  const withAnalytics = useWithAnalytics();

  const onBrandClick = () => {
    withAnalytics(undefined, {
      track: true,
      target: HEADER_ANALYTICS_TARGET.SEARCH,
      action: ANALYTICS_EVENT_ACTION_PERFORMED,
      eventProperties: {
        brand_id: id,
        brand_name: name,
        search_result_type: ANALYTICS_TARGET_BRAND,
      },
    })();
    handleClick?.();
  };

  return (
    <Link
      className={`${styles.searchedItem} ${styles.brandItemBlock}`}
      prefetch={false}
      href={{
        pathname: getBrandRoute({
          brandSlug: key || id,
          storeBasePath,
        }),
      }}
      onClick={onBrandClick}
    >
      <span className={styles.brandName}>{name}</span>
    </Link>
  );
};

export default SearchedBrand;
